import React, { useState } from "react";
import { Data, StepData, ThankYouInterface } from "../../../Context";
import StepResultCard from "../StepResultCard";
import { MediaPlayer, MediaProvider } from "@vidstack/react";

interface Props {
    step : StepData;
    magnetData : Data,
    end : ThankYouInterface
    idx : number,
    videoUrl : string,
    created_date : string,
}

const EndStepResults = ({ step, magnetData, end, idx, videoUrl, created_date } : Props) : React.ReactElement => {
    const [bgColor, setBgColor] = useState<any>(JSON.parse(JSON.stringify(end.textScreenStyle!.backgroundColor)));
    const [mobile, setMobile] = useState<boolean>(false);

    return(
        <div key={idx} className="bg-brandLightGray p-5 mt-5 mb-5 flex lg:flex-row max-lg:flex-col flex-wrap rounded-xl gap-3 justify-start items-center">
            <p className="text-xl font-bold gap-3">Step {idx + 1}: <span className="font-normal">{"End Screen"}</span></p>
            <div className="flex lg:flex-row max-lg:flex-col xl:w-4/5 max-xl:w-full gap-3">
                <StepResultCard title="End Views" 
                color={`${(step.start && (step.start / magnetData.steps14Days[idx - 1].finish) * 100 > 50)?"bg-green":"bg-red"}`} 
                textColor="text-white"
                result={(step.start) ? step.start : 0} percentage={false} 
                comparison={(magnetData.stepsComparison[idx]) ? magnetData.stepsComparison[idx].start : 0} loadign={false}/>

                <StepResultCard title="CTA Clicks" 
                color={`${(step.finish && (step.finish / step.start) * 100 > 50)?"bg-green":((step.finish / step.start) * 100 > 25)?"bg-yellow":"bg-red"}`} 
                textColor={`${(step.finish && (step.finish / step.start) * 100 > 50)?"text-white":((step.finish / step.start) * 100 > 25)?"text-black":"text-white"}`}
                result={(step.finish) ? step.finish : 0} percentage={false} 
                comparison={(magnetData.stepsComparison[idx]) ? magnetData.stepsComparison[idx].finish : 0} loadign={false}/>

                <StepResultCard title="Completion Rate" 
                color={`${(step.finish && (step.finish / step.start) * 100 > 50)?"bg-green":((step.finish / step.start) * 100 > 25)?"bg-yellow":"bg-red"}`} 
                textColor={`${(step.finish && (step.finish / step.start) * 100 > 50)?"text-white":((step.finish / step.start) * 100 > 25)?"text-black":"text-white"}`}
                result={(step.finish) ? step.finish / step.start * 100 : 0} percentage={true} 
                comparison={(magnetData.stepsComparison[idx]) ? (magnetData.stepsComparison[idx].finish / magnetData.stepsComparison[idx].start) * 100 : 0} loadign={false}/>
            </div>
            {
                (!isNaN(Date.parse(created_date)))
                ?<div className={`w-full rounded-lg flex justify-center items-center shadow-md`}>
                    <MediaPlayer playsInline className='relative w-full h-full flex justify-center items-center rounded-lg'
                    title='Test video' src={videoUrl}>
                    <MediaProvider>
                    </MediaProvider>
                    {
                        ( end.textScreenStyle.backgroundImage.length > 0 )
                        ?<img src={end.textScreenStyle.backgroundImage} alt="form thumbnail" className="z-10 rounded-lg" />
                        :null
                    }
                    <div className={`absolute z-10 rounded-lg w-[calc(100%+5px)] h-[calc(100%+5px)] flex justify-center items-center`} 
                        style={{background : `rgba(${bgColor.r},${bgColor.g},${bgColor.b}, ${bgColor.a})`}}>
                        <div className={`w-[80%] flex flex-col justify-center`} 
                        style={{gap : `${(!mobile)? end.textScreenStyle.gap + "rem" : end.textScreenStyle.gap * 0.75 + "rem" }`, alignItems : `${end.textScreenStyle.textAlign}`}}>
                            {
                            (end.h1.length > 0)
                            ?<p style={{
                                color : `${end.h1Style.color}`,
                                fontSize : `${end.h1Style.fontSize}rem`
                            }}>{end.h1}</p>
                            :null
                            }
                            {
                            (end.description.length > 0)
                            ?<p style={{
                                color : `${end.pStyle.color}`,
                                fontSize : `${end.pStyle.fontSize}rem`
                            }}>{end.description}</p>
                            :null
                            }
                            <div className="flex flex-wrap items-center" style={{gap : `${(!mobile)? end.textScreenStyle.gap + "rem" : end.textScreenStyle.gap * 0.75 + "rem" }`}}>
                            {end.ctaList!.map((cta : any, idx : number) => {
                                return(
                                <button className={`font-light border-none`} key={idx}
                                style={{
                                    backgroundColor : `${end.ctaStyle[idx].backgroundColor}`,
                                    color : `${end.ctaStyle[idx].color}`,
                                    fontSize : `${end.ctaStyle[idx].fontSize}rem`,
                                    padding : `${end.ctaStyle[idx].padding}rem`,
                                    borderRadius : `${end.ctaStyle[idx].borderRadius}px`
                                }}
                                onClick={()=>{window.open(cta.url, "_blank");}}>{cta.text}</button>
                                );
                            })}
                            </div>
                        </div>
                        </div>
                    </MediaPlayer>
                </div>
                :null
            }
        </div>
    );
};

export default EndStepResults;